import React from "react";
import { Label } from "reactstrap";
import { TabPane, Row, Col } from "reactstrap";
import "./index.css";
import CustomTextInput from "../../../../components/CustomTextInput";
import CustomDropdownInput from "../../../../components/CustomDropdownInput";

interface PopulationInformationTabProps {
  isView: boolean;
  siteData: any;
  setSiteData: Function;
}

export default function PopulationInformationTab({
  isView,
  siteData,
  setSiteData,
}: PopulationInformationTabProps) {
  const updateAttr = (attribute: string, value: any) => {
    let dataUpdate = {};
    if (value?.label) {
      // Check value is object (value from dropdown menu)
      dataUpdate = {
        [attribute]: {
          id: value?.value,
          name: value?.label,
        },
      };
    } else {
      dataUpdate = { [attribute]: value };
    }
    setSiteData({
      ...siteData,
      ...{ data: { ...siteData?.data, ...dataUpdate } },
    });
  };

  const uiLayoutDefinition: any = [
    {
      type: "row",
      label: "Khu vực office",
      items: [
        {
          attributeName: "population_office_inbuilding",
          type: "text",
          size: 4,
        },
        {
          attributeName: "population_office_inbuilding_conversion_rate",
          type: "text",
          size: 4,
        },
        { type: "break" },
        {
          attributeName: "target",
          type: "custom",
          value:
            siteData?.data["population_office_inbuilding"] *
            siteData?.data["population_office_inbuilding_conversion_rate"],
          size: 4,
        },
        { type: "break" },
        { type: "break" },
        { attributeName: "population_office_300m", type: "text", size: 4 },
        {
          attributeName: "population_office_300m_conversion_rate",
          type: "text",
          size: 4,
        },
        { type: "break" },
        {
          attributeName: "target",
          type: "custom",
          value:
            siteData?.data["population_office_300m"] *
            siteData?.data["population_office_300m_conversion_rate"],
          size: 4,
        },
        { type: "break" },
        { type: "break" },
        { attributeName: "population_office_500m", type: "text", size: 4 },
        {
          attributeName: "population_office_500m_conversion_rate",
          type: "text",
          size: 4,
        },
        { type: "break" },
        {
          attributeName: "target",
          type: "custom",
          value:
            siteData?.data["population_office_500m"] *
            siteData?.data["population_office_500m_conversion_rate"],
          size: 4,
        },
        { type: "break" },
        { type: "break" },
      ],
    },
    {
      type: "row",
      label: "Khu vực dân cư",
      items: [
        { attributeName: "population_residential_300m", type: "text", size: 4 },
        {
          attributeName: "population_residential_300m_conversion_rate",
          type: "text",
          size: 4,
        },
        { type: "break" },
        {
          attributeName: "target",
          type: "custom",
          value:
            siteData?.data["population_residential_300m"] *
            siteData?.data["population_residential_300m_conversion_rate"],
          size: 4,
        },
        { type: "break" },
        { type: "break" },
        { attributeName: "population_residential_500m", type: "text", size: 4 },
        {
          attributeName: "population_residential_500m_conversion_rate",
          type: "text",
          size: 4,
        },
        { type: "break" },
        {
          attributeName: "target",
          type: "custom",
          value:
            siteData?.data["population_residential_500m"] *
            siteData?.data["population_residential_500m_conversion_rate"],
          size: 4,
        },
        { type: "break" },
        { type: "break" },
        { attributeName: "population_residential_700m", type: "text", size: 4 },
        {
          attributeName: "population_residential_700m_conversion_rate",
          type: "text",
          size: 4,
        },
        { type: "break" },
        {
          attributeName: "target",
          type: "custom",
          value:
            siteData?.data["population_residential_700m"] *
            siteData?.data["population_residential_700m_conversion_rate"],
          size: 4,
        },
        { type: "break" },
        { type: "break" },
      ],
    },
    {
      type: "row",
      label: "Khu vực khác",
      items: [
        { attributeName: "population_student_1000m", type: "text", size: 4 },
        {
          attributeName: "population_student_1000m_conversion_rate",
          type: "text",
          size: 4,
        },
        { type: "break" },
        {
          attributeName: "target",
          type: "custom",
          value:
            siteData?.data["population_student_1000m"] *
            siteData?.data["population_student_1000m_conversion_rate"],
          size: 4,
        },
        { type: "break" },
        { type: "break" },
        { attributeName: "population_shopping_mall", type: "text", size: 4 },
        {
          attributeName: "population_shopping_mall_conversion_rate",
          type: "text",
          size: 4,
        },
        { type: "break" },
        {
          attributeName: "target",
          type: "custom",
          value:
            siteData?.data["population_shopping_mall"] *
            siteData?.data["population_shopping_mall_conversion_rate"],
          size: 4,
        },
        { type: "break" },
        { type: "break" },
        { attributeName: "population_others", type: "text", size: 4 },
        {
          attributeName: "population_others_conversion_rate",
          type: "text",
          size: 4,
        },
        { type: "break" },
        {
          attributeName: "target",
          type: "custom",
          value:
            siteData?.data["population_others"] *
            siteData?.data["population_others_conversion_rate"],
          size: 4,
        },
        { type: "break" },
        { type: "break" },
      ],
    },
  ];

  return (
    <TabPane tabId="population_information_tab" style={{}}>
      {uiLayoutDefinition.map((row:any, rowIndex:number) => (
        <Row key={`row-index-${rowIndex}`} className="store-information-tab__section">
          <Col sm={{ size: 4, offset: 0 }}>
            <Label style={styles.customTextInput}>{row.label}</Label>
          </Col>
          {row.items.map((layoutItem:any, layoutItemIndex:number) => {
            if (layoutItem.type === "dropdown") {
              return (
                <Col key={`layout-item-${layoutItemIndex}`} sm={{ size: layoutItem.size, offset: 0 }}>
                  <CustomDropdownInput
                    disabled={isView}
                    style={styles.customTextInput}
                    callback={updateAttr}
                    data={siteData?.data}
                    options={layoutItem.options}
                    labels={siteData?.labels}
                    attributeName={layoutItem.attributeName}
                  />
                </Col>
              );
            } else if (
              layoutItem.type === "text" ||
              layoutItem.type === "textarea"
            ) {
              return (
                <Col key={`layout-item-${layoutItemIndex}`} sm={{ size: layoutItem.size, offset: 0 }}>
                  <CustomTextInput
                    type={layoutItem.type}
                    disabled={isView}
                    style={styles.customTextInput}
                    callback={updateAttr}
                    data={siteData?.data}
                    labels={siteData?.labels}
                    attributeName={layoutItem.attributeName}
                  />
                </Col>
              );
            } else if (layoutItem.type === "custom") {
              return (
                <Col key={`layout-item-${layoutItemIndex}`} sm={{ size: layoutItem.size, offset: 0 }}>
                  <CustomTextInput
                    type={"text"}
                    disabled={true}
                    style={styles.customTextInput}
                    callback={updateAttr}
                    data={{ [layoutItem.attributeName]: layoutItem.value }}
                    labels={{ [layoutItem.attributeName]: "Có thể target" }}
                    attributeName={layoutItem.attributeName}
                  />
                </Col>
              );
            } else if (layoutItem.type === "break") {
              return <Col key={`layout-item-${layoutItemIndex}`} sm={{ size: 4, offset: 0 }} />;
            }
          })}
        </Row>
      ))}
    </TabPane>
  );
}

const styles = {
  customTextInput: {
    marginTop: 20,
  },
};
